export const packageManagerModule = `# 通用模組：套件管理約束（pnpm 強制）

> 版本：v1.0
> 適用場景：所有 PromptForge 輸出的專案
> 約束：本專案必須使用 pnpm 作為套件管理器

---

## 1. 為什麼強制使用 pnpm

- 磁碟空間效率：pnpm 使用硬鏈接，Monorepo 場景下節省大量空間
- 依賴隔離：node_modules 結構嚴格，避免幽靈依賴
- 與現有架構一致：Cloudflare Pages + Workers 專案在 pnpm 下有更好的 lockfile 一致性

---

## 2. 強制約束

- 絕對不可使用 \`npm install\` 或 \`yarn\`
- 所有 \`package.json\` 的 scripts 應以 \`pnpm\` 為前綴
- CI/CD（GitHub Actions）必須使用 \`pnpm\` 安裝依賴
- lockfile 必須是 \`pnpm-lock.yaml\`

---

## 3. 常用指令

\`\`\`bash
# 安裝依賴
pnpm install

# 本地開發
pnpm dev

# 構建
pnpm build

# 部署 Worker
cd apps/cms-worker && pnpm deploy

# 部署前台
cd apps/web && pnpm build && pnpm deploy
\`\`\`

---

## 4. CI/CD 範例

\`\`\`yaml
- uses: pnpm/action-setup@v4
  with:
    version: 10
- uses: actions/setup-node@v4
  with:
    node-version: '20'
    cache: 'pnpm'
- run: pnpm install --frozen-lockfile
- run: pnpm build
\`\`\`

---

## 5. 常見陷阱

- **T-npm**: 使用 npm 安裝會導致 lockfile 混亂，後續 pnpm 安裝可能出現版本不一致
- **T-yarn**: yarn 的 resolutions 與 pnpm 的 overrides 語法不同，不可混用
- **T-ci**: CI 中未指定 \`--frozen-lockfile\` 可能導致生產環境安裝到未預期版本
`;
